module.exports = __webpack_public_path__ + "static/media/T.498cb000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/T.jpg
// module id = 88
// module chunks = 0